module.exports = __webpack_public_path__ + "static/mr-press-20-db2904de5eaf131c5ed70be271a43b39.jpg";